<template>
  <v-container :class="[$vuetify.breakpoint.xsOnly ? 'ma-0 pa-0' : '']">
    <v-card height="100%" color="#FAFAFA">
      <v-card-title
        :class="[$vuetify.breakpoint.xsOnly ? 'd-block' : 'd-flex']"
        :style="'cursor: pointer; pointer-events: visible;background-color:'+(workRequest.StageCode == 'A' || workRequest.StageCode == 'O' ? 'grey' : 'green')+'; color:white;padding-top:5px;padding-bottom:5px;'"
      >
        <v-flex>
          <i :title="$t('equipment.workRequests.priority')" class="mr-2 ml-1 fab fa-hotjar" :style="{fontSize: priorityStyle(workRequest.Priority) + 'px'}" :class="[priorityClass(workRequest.Priority)]"></i>
          <span :title="$t('equipment.workRequests.priority')" :style="{fontSize: priorityStyle(workRequest.Priority) - 5 + 'px'}">{{workRequest.Priority}}</span>
        </v-flex>
        <!-- <v-icon dark left :color="workRequest.Color">{{workRequest.Icon}}</v-icon> -->
        <v-flex pr-3>
          <v-icon class="mr-1" color="blue">directions</v-icon>
          <span>{{workRequest.DirectionName + ' '}}</span>
        </v-flex>
        <v-flex>
          <v-icon class="mr-1" color="orange">category</v-icon>
          <span>{{workRequest.CategoryName}}</span>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex text-xs-right>
          <span class="subheading">№ {{workRequest.IdApplication}}</span>
        </v-flex>
      </v-card-title>

      <v-card-text>
        <v-layout column>
          <v-layout
            class="subheading font-weight-light"
            :wrap="$vuetify.breakpoint.smAndUp"
            :column="!$vuetify.breakpoint.smAndUp"
          >
            <!-- <v-flex v-if="workRequest.DeclarerName"> -->
            <WorkRequestAdditionalInfo v-if="workRequest.DeclarerName" :workRequest="workRequest" />
            <!-- <v-icon class="mr-1" color="green">person</v-icon>
            <span>{{ workRequest.DeclarerName }}</span>-->
            <!-- </v-flex> -->

            <!-- <v-flex > -->
            <!-- <WorkRequestAdditionalInfo
              v-if="workRequest.ResponsibleName"
              :workRequest="workRequest"
              :declarer="true"
            />-->
            <!-- <v-icon class="mr-1" color="orange">directions_run</v-icon>
            <span>{{ workRequest.ResponsibleName }}</span>-->
            <!-- </v-flex> -->
            <v-spacer></v-spacer>
            <v-layout
              style="display: block"
              align-center
              fill-height
              :justify-end="$vuetify.breakpoint.smAndUp"
              :text-xs-right="!$vuetify.breakpoint.xsOnly"
              :class="[$vuetify.breakpoint.xsOnly ? 'mb-3' : 'mx-1']"
            >
              <v-icon color="blue">access_time</v-icon>
              <span class="mx-2 title">{{ workRequest.TimeAfterCreation }}</span>
              <v-btn
                icon
                v-if="workRequest.AttachmentCount"
                :title="$t('equipment.workRequests.pictures')"
                @click.native.stop="$router.push({ name: 'WorkRequestAttachments', params: { workRequestId: workRequest.IdApplication } })"
              >
                <v-icon>attach_file</v-icon>
              </v-btn>
            </v-layout>
          </v-layout>
          <p
            class="font-weight-medium subheading"
            style="word-wrap:break-word"
            v-if="contentLength(workRequest.Content)"
          >{{workRequest.Content}}</p>
          <p v-else class="font-weight-medium subheading" style="word-wrap:break-word">
            {{ openText(workRequest.Content)}}
            <v-btn tile icon small class="ma-0" @click="fullText = !fullText">
              <v-icon>{{!fullText ? 'fa-angle-down' : 'fa-angle-up'}}</v-icon>
            </v-btn>
          </p>
          <v-divider />
          <router-link
            v-if="workRequest.EquipmentCode"
            :to="{ name: 'equipment', params: { equipmentId: workRequest.EquipmentCode }}"
          >
            <span
              class="subheading font-weight-light text--lighten-blue"
            >{{workRequest.EquipmentName}} ({{workRequest.EquipmentCode}})</span>
          </router-link>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout wrap>
          <v-layout align-center justify-end>
            <WorkRequestStageButtons :workRequest="workRequest" />
            <!-- <WorkRequestAdditionalForm :workRequest="workRequest" /> -->

            <!-- <v-menu v-model="menu" :close-on-content-click="false" lazy left offset-y full-width>
              <template slot="activator">
                <v-flex pr-2>
                  <v-btn color="orange" dark icon :loading="loading">
                    <v-icon>{{workRequest.StageCode == 'R' ? 'person_add' : 'people'}}</v-icon>
                  </v-btn>
                </v-flex>
              </template>
              <v-card>
                <v-list>
                  <v-list-tile
                    v-for="(item, index) in responsibleList"
                    :key="index"
                    @click="menu=false; if(item.Code)
                    modifyWorkRequests({workRequestId : workRequest.IdApplication, action: workRequest.StageCode == 'R' ?'setperformer':'changeperformer', additionalParams: item.Code})"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title>{{ item.Name }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-menu>-->
          </v-layout>
        </v-layout>
      </v-card-actions>
    </v-card>
    <v-layout class="main">
      <v-card
        class="main"
        :class="$vuetify.breakpoint.xsOnly ? 'mt-2' : 'mt-5'"
        style="width: 100%; "
      >
        <v-card-title>
          <h2 class="pl-2">{{ $t('equipment.workRequests.messenger') }}</h2>
        </v-card-title>
        <v-card-text class="py-0">
          <v-layout 
            d-block
            :class="[ $vuetify.breakpoint.xs ? 'pa-1' : 'px-2 pb-0']"
            style=" overflow: auto"
            :style="[$vuetify.breakpoint.xsOnly ? 'max-height: 100vh' : 'max-height: 25vh']"
          >
            <v-flex v-for="(item, index) in comments" :key="index" style="width: 100%">
              <p class="body-2 ma-0">
                {{ item.USER }}
                <span
                  class="grey--text mb-0"
                  style="font-size: 10px"
                >{{jsonToDate(item.DATE)}}</span>
              </p>
              <p class="darkgrey--text mb-1">{{ item.TEXT }}</p>
            </v-flex>
          </v-layout>
          <v-text-field
            v-model="comment"
            :label="$t('enterComment')"
            :class="[$vuetify.breakpoint.xs ? 'pa-0' : 'px-2']"
            @keyup.enter="commentAction()"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat
            @click="commentAction()"
          >{{ $t('submit') }}</v-btn>
        </v-card-actions>

        <!-- <v-list style="height: auto">
          <v-list-tile ripple tag="v-flex" style="height: 100%" v-for="(item, index) in comments" :key="index">
          <v-list-tile-content style="height: 100%">
          <v-list-tile-title>{{ item.USER }}</v-list-tile-title>
          <v-list-tile-sub-title style="white-space: normal;">{{ item.TEXT }}</v-list-tile-sub-title>
          </v-list-tile-content>
          </v-list-tile>
        </v-list>-->

        <!-- <v-btn
          color="green darken-1"
          flat
          @click="commentDialog = false"
        >{{ $t('cancel') }}</v-btn>-->
      </v-card>
    </v-layout>

    <v-layout style="display: block" :class="$vuetify.breakpoint.xsOnly ? 'mt-2' : 'mt-5'">
      <v-expansion-panel
        v-model="calendarPanel"
        :class="[$vuetify.breakpoint.xsOnly ? 'mb-3' : '']"
      >
        <v-expansion-panel-content class="main">
          <template v-slot:actions>
            <v-icon size="25px" color="blue" class="ml-2">$vuetify.icons.expand</v-icon>
          </template>
          <template v-slot:header>
            <v-icon size="25px" color="blue" class="mr-2">calendar_today</v-icon>
            <span class="font-weight-bold">{{ $t('equipment.workRequests.calendar') }}</span>
          </template>
          <v-list class="caption main">
            <v-list-tile v-for="(item, index) in calendar" :key="index">
              <v-list-tile-content>
                <v-list-tile-action-text class="caption px-2">{{index + 1}}</v-list-tile-action-text>
              </v-list-tile-content>
              <v-list-tile-content>
                <v-list-tile-title class="caption" v-text="item.StageName"></v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-content>
                <v-list-tile-title class="caption" v-text="jsonToDate(item.StageTime)"></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-layout>
  </v-container>
</template>


<script>
import WorkRequestStageButtons from "../components/WorkRequestStageButtons";
import WorkRequestAdditionalInfo from "../components/WorkRequestAdditionalInfo";
//import OperationPlanTable from '../components/OperationPlanTable'

import { mapActions } from "vuex";

export default {
  name: "workRequestCardPage",
  components: {
    WorkRequestStageButtons,
    WorkRequestAdditionalInfo
    //OperationPlanTable
  },
  props: {
    workRequest: Object,
    validator: function(value) {
      return ["idapplication", "StageCode"].indexOf(value) !== -1;
    }
  },
  mounted() {
    this.updateComments({ workRequestId: this.workRequestId })
  },
  methods: {
    ...mapActions([
      "modifyWorkRequests",
      "updatePerformers",
      "updateComments",
      "updateWorkRequestAttachments",
      "updateWorkRequests",
      "updateCalendar",
      "updateAttachments"
    ]),
    priorityClass(value){
      return value <= 3 ? "red--text" : value <= 7 ? "orange--text" : "yellow--text"
    },
    priorityStyle(value){
      return 28 - value;
    },
    jsonToDate(stage) {
      let date = new Date(parseInt(stage.substr(6)));
      return date.toLocaleString("ru-Ru");
    },
    contentLength(str) {
      return str.length < 300;
    },
    openText(content) {
      return this.fullText ? content : content.substring(0, 300);
    },
    commentAction() {
      this.modifyWorkRequests({
        workRequestId: this.workRequest.IdApplication,
        action: "comment",
        additionalParams: this.comment
      }).then(() => {
        this.comment = "";
        this.updateComments({ workRequestId: this.workRequest.IdApplication });
      });
    }
  },
  data() {
    return {
      calendarPanel: [true],
      dialogFinish: false,
      closeDialog: false,
      toDeclarerDialog: false,
      cancelDialog: false,
      hideImageControls: false,
      comment: "",
      //menu: false,
      fab: false,
      rating: null,
      fullText: null
    };
  },
  computed: {
    calendar() {
      return this.$store.state.workRequests.calendar;
    },
    comments() {
      return this.$store.state.workRequests.comments;
    },
    attachments() {
      return this.$store.state.workRequests.attachments;
    },
    loading() {
      return this.$store.state.base.loading;
    },
    workRequestId() {
      return parseInt(this.$route.params.idapplication);
    },
    currentLocale() {
      return this.$store.getters.currentLocale;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    }
  },
  watch: {
    calendarPanel() {
      if (this.workRequestId) {
        this.updateCalendar({ workRequestId: this.workRequestId });
      }
    },
    isAuthenticated() {
      if (this.workRequestId) {
        this.updateWorkRequests({ workRequestId: this.workRequestId });
      }
    },
    currentLocale() {
      if (this.workRequestId) {
        this.updateWorkRequests({ workRequestId: this.workRequestId });
      }
    },
     isAuthenticated() {
      this.updateWorkRequests();
    }
  }
};
</script>

<style scoped>
a {
  text-decoration: none !important;
  color: blue !important;
}
</style>